import ImageSource from '../types/ImageSource';

export default function formatRepliersImageSource(
  imageName: string,
  size: 'small' | 'medium' | 'large' = 'medium',
): ImageSource {
  // cdn.tophouse.com has a CNAME records mapping it to repliers
  const uri = `https://cdn.tophouse.com/${imageName}?class=${size}`;

  return {
    uri,
    headers: { 'User-Agent': 'TopHouse' },
  };
}
